/* eslint-disable no-unused-vars */
import { Button } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Collapse from "@mui/material/Collapse";
import { red } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import { createStyles, Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import clsx from "clsx";
import React, { useEffect } from "react";
import API from "../../utils/API";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: 15,
    },
    media: {
      height: 0,
      paddingTop: "56.25%", // 16:9
    },
    expand: {
      transform: "rotate(0deg)",
      marginLeft: "auto",
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: "rotate(180deg)",
    },
    avatar: {
      backgroundColor: red[500],
    },
  })
);

export default function SettingsCard(props) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [id, setId] = React.useState(null);
  const [intVersion, setIntVersion] = React.useState(0);
  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    try {
      const { data } = await API.get("/api/v1/setting/" + props.settingKey);
      populateObject(data);
    } catch (err) {
      if (props.ignoreLoadError) {
      } else {
        props.messagHandler("error", "Error While loading Data");
      }
    }
  }

  function populateObject(bean) {
    setId(bean.id);
    setIntVersion(bean.intVersion);
    props.populateObject(bean);
  }

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  async function onSave() {
    if (props.onValidate) {
      if (!props.onValidate()) {
        return;
      }
    }

    var payload = createPayload();

    try {
      let { data } = await API.post(
        "/api/v1/setting/" + props.settingKey,
        payload
      );
      populateObject(data);
      props.messagHandler("success", "Settings Saved");
    } catch (err) {
      console.log(err);
      props.messagHandler(
        "error",
        "Not able to save Setting " + err.response.status
      );
      //console.log(err.response.data.apierror.message);
      //this.showError(err.response.data.apierror);
    }
  }

  function createPayload() {
    let payload = Object.create(null);
    payload["id"] = id;
    payload["intVersion"] = intVersion;
    props.createPayload(payload);
    return payload;
  }

  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            {props.avatar}
          </Avatar>
        }
        title={props.title}
      />

      <CardContent>{props.cardContent}</CardContent>

      <CardActions disableSpacing>
        <div style={{ flex: "1 0 0" }} />
        <Button onClick={onSave} variant="contained" color="primary">
          Apply
        </Button>
        {props.expandContent && (
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        )}
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>{props.expandContent}</CardContent>
      </Collapse>
    </Card>
  );
}
